import { render, staticRenderFns } from "./local.vue?vue&type=template&id=d1142b44&scoped=true"
import script from "./local.vue?vue&type=script&lang=js"
export * from "./local.vue?vue&type=script&lang=js"
import style0 from "./local.vue?vue&type=style&index=0&id=d1142b44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1142b44",
  null
  
)

export default component.exports